// SPEC-LAUNCHER-MODULE-LABEL-COLORBAR-01: モジュール色SSOT
// PageHeader の THEME_COLORS を置換。admin は manesupport の別名(同値青)
export const MODULE_COLORS = {
  clawsupport: '#ec4899',
  tanasupport:  '#10b981',
  manesupport:  '#3b82f6',
  admin:        '#3b82f6',
}
